import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { setLocal, getLocal } from '@shared/components/localStorage';

import { Icon, Dropdown, Modal, Button, message } from '@tencent/ten-design-react';
import NavbarGroup from './navbarGroup';
import NavbarHeading from './navbarHeading';
// import defaultLogo from '../../assets/images/default_project.png';

import styles from './navbar.less';

const userNav = [
  {
    title: 'Change Password',
    index: 0,
  },
  {
    title: 'Log Out',
    index: 1,
  },
];

const navList = [
  {
    title: 'LP Management',
    link: '/lp-management',
    permission: 'system.header.lp.view',
  },
  {
    title: 'Folder',
    link: '/document',
    permission: 'system.header.document.view',
  },
  {
    title: 'LP Monitor',
    link: '/lp-monitor',
    permission: 'system.header.mnt.view',
  },
  {
    title: 'Setting',
    link: '/setting',
    permission: 'system.header.setting.view',
  },
];
class Navbar extends Component {
  static propTypes = {
    t: PropTypes.func,
    getMonitoringCompany: PropTypes.func,
    monitoring: PropTypes.array,
    user: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      navList,
      visibleAlert: false,
    };
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  async componentDidMount() {
    const { dispatch, user } = this.props;
    if (isEmpty(user)) {
      try {
        const res = await dispatch.getUser();
        // is_tmp_pwd: 1为临时密码 2为非临时
        if (res.is_tmp_pwd === 1 && !getLocal('PWD_ALERT')) {
          this.setState({
            visibleAlert: true,
          });
        }
      } catch (e) {
        message.error(e);
      }
    }
  }

  async handleLogout() {
    const { dispatch, history } = this.props;
    try {
      await dispatch.logout();
      history.push('/login');
    } catch (e) {
      message.error(e);
    }
  }

  handleItemClick(item) {
    const { history } = this.props;
    if (item.index === 0) {
      history.push('/reset-password');
    }
    if (item.index === 1) {
      this.handleLogout();
    }
  }

  handleConfirm() {
    setLocal('PWD_ALERT', '1');
    const { history } = this.props;
    history.push('/set-password');
  }

  handleClose() {
    setLocal('PWD_ALERT', '1');
    this.setState({
      visibleAlert: false,
    });
  }

  render() {
    const { user } = this.props;
    return (
      <div className={styles.nav}>
        <div className={styles.container}>
          <NavbarGroup>
            <NavbarHeading>
              <h1>
                <NavLink to="/" className={user?.rtx_id && styles.innerLogo}>
                  TIP
                </NavLink>
              </h1>
            </NavbarHeading>
          </NavbarGroup>
          <NavbarGroup className={styles.menus}>
            {this.state.navList.map(
              (nav, index) =>
                user?.permissions?.includes(nav.permission) && (
                  <NavLink key={index} to={nav.link} activeClassName={styles.active}>
                    {nav.title}
                  </NavLink>
                ),
            )}
          </NavbarGroup>
          <NavbarGroup className={classNames(styles.menus, styles.profile)}>
            <Dropdown
              className={classNames(styles.dropdown)}
              triggerType="hover"
              data={userNav}
              onItemClick={(item) => this.handleItemClick(item)}
              getItemKey={(item) => item.title}
              renderItem={(item) => <span>{item.title}</span>}
              direction="bottom right"
            >
              <div className={styles.user}>
                <Icon type="setting" className={styles.avatar}></Icon>
              </div>
            </Dropdown>
          </NavbarGroup>
        </div>

        <Modal
          footerBtns={[
            <Button key="cancel" clickType="cancel">
              Close
            </Button>,
            <Button theme="primary" key="confirm" clickType="confirm">
              Set Password
            </Button>,
          ]}
          maskClosable={false}
          title="Set Password"
          visible={this.state.visibleAlert}
          onClose={this.handleClose}
          onConfirm={this.handleConfirm}
          onCancel={this.handleClose}
        >
          <p>Click Set Password below to set your own password.</p>
        </Modal>
      </div>
    );
  }
}

const mapState = ({ auth }) => ({ ...auth });
const mapDispatch = ({ auth }) => ({ dispatch: auth });

export default withTranslation()(connect(mapState, mapDispatch)(Navbar));
